import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

interface Props {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  fallback?: React.ReactNode;
}

export function AuthImage({ src, alt, className, style, fallback }: Props) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    let objectUrl: string | null = null;
    setFailed(false);
    setBlobUrl(null);

    api
      .get<Blob>(src, { responseType: 'blob', signal: controller.signal })
      .then((res) => {
        objectUrl = URL.createObjectURL(res.data);
        setBlobUrl(objectUrl);
      })
      .catch((err: { code?: string }) => {
        if (err?.code !== 'ERR_CANCELED') setFailed(true);
      });

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (failed) return <>{fallback ?? null}</>;
  if (!blobUrl) return <div className={`${className ?? ''} animate-pulse bg-muted rounded`} style={style} />;
  return <img src={blobUrl} alt={alt} className={className} style={style} />;
}
